export const getStoredUserDetail = () => {
    try {
        const raw = localStorage.getItem('userDetail');
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        return null;
    }
};

export const saveUserDetail = (userDetail) => {
    if (!userDetail) {
        localStorage.removeItem('userDetail');
        return;
    }
    localStorage.setItem('userDetail', JSON.stringify(userDetail));
};

export const DEFAULT_USER_AVATAR = 'assets/images/users/avatar-1.png';

export const getUserAvatar = (user) => {
    const img = user?.profileImg;
    if (img && typeof img === 'string' && img.trim()) {
        return img.trim();
    }
    return DEFAULT_USER_AVATAR;
};

export const getUserDisplayName = (user) => {
    if (!user) return 'User';
    const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
    return fullName || user.email || 'User';
};
